import moment from 'moment'

const getCurrentDayForecast = (data, city) => ({
  weekday: moment(data.dt_txt).format('dddd'),
  date: moment(data.dt_txt).format('MMMM Do'),
  location: `${city.name},${city.country}`,

  temperature: Math.round(data.main.temp),
  minTemp: Math.round(data.main.temp_min),
  maxTemp: Math.round(data.main.temp_max),
  humidity: Math.round(data.main.humidity),
  weatherIcon: `https://openweathermap.org/img/wn/${data.weather[0].icon}@2x.png`,
  weatherDescription: data.weather[0].main,
  population: city.population,
  pressure: Math.round(data.main.pressure),
  description: data.weather[0].description,
  coordLat: city.coord.lat,
  coordLon: city.coord.lon,
})

export default getCurrentDayForecast
